import Page from './layouts/Page';
import './styles/static-site.scss';

const AboutUs = () => {
  return (
    <Page>
      <h1>About Stargid</h1>
      <p>
        Stargid Event Management was found by three members who spent hard times managing events and built the solution that they could not find
        elsewhere. As a Startup company evolved over a year ago, we achieved our goal of providing a truly end-to-end event solution—from registration
        to attendee tracking to detailed reporting—completing our mission to provide meeting and event planners with what they need, when they need
        it.
      </p>
      <p>
        With responsive team, proven tools and a transformative approach to create, shape and execute a first-class event and attendee experience,
        there is no other event technology company in the market that has the commitment to help clients connect better while also improving their
        business objectives.
      </p>
      <h6>We want to connect with you!</h6>
      <p>
        We would love the chance to speak with you about your event technology needs. Tell us what is on your mind and we will make sure that someone
        from the Stargid team reaches out to answer your question. Please contact or reach out to our sales and support team directly through the
        email and phone numbers below. We look forward to hearing from you!
      </p>
    </Page>
  );
};

export default AboutUs;
